/*
 * @Author: songyzh
 * @Date: 2020-08-20 10:47:00
 * @LastEditors: songyzh
 * @LastEditTime: 2020-08-20 14:10:07
 */
const storage = {
  setItem: (key, value, expired) => {
    localStorage.setItem(key, value);
    if (expired) {
      localStorage.setItem(`${key}__expires__`, Date.now() + 1000 * 60 * expired);
    }
  },
  getItem: (key) => {
    const expired = localStorage.getItem(`${key}__expires__`) || Date.now() + 1;
    const now = Date.now();

    if (now >= expired) {
      storage.remove(key);
      return null;
    }
    const value = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : localStorage.getItem(key);
    return value;
  },
  remove: (key) => {
    localStorage.removeItem(key);
    localStorage.removeItem(`${key}__expires__`);
  }
};
export default storage;
